import React, { Component } from 'react'

import { translation } from '../../../../utils/helpers'
import Button from '../../../elements/button'
import Check from '../../../elements/check'
import CloseButton from '../../../elements/closeButton'
import Grid from '../../../elements/grid'
import Inline from '../../../elements/inline'

import './filterBar.scss'

class FilterBar extends Component {
  constructor (props) {
    super(props)
    this.openFilterSlidePanel = this.openFilterSlidePanel.bind(this)
  }

  onChange (e) {
    if (this.props.onChange !== null) {
      this.props.onChange(e)
    }
  }

  openFilterSlidePanel (e) {
    if (this.props.openFilterSlidePanel !== null) {
      this.props.openFilterSlidePanel(e)
    }
  }

  render () {
    return (
      <div>
        <Grid cols={[ 1, 'min-content' ]} align='center'>
          <div className='filter-bar__items'>
            <Inline spacing={0}>
              <span className='filter-bar__title'>{translation('16659')}</span>
            </Inline>

            <Inline spacing={0}>
              <Check
                name='arrived'
                labelText={14798}
                spacing={0}
                checked={this.props.filter.arrived}
                onChange={this.props.onChange}
              />
            </Inline>

            <Inline spacing={0}>
              <Check
                name='estimationApproved'
                labelText={translation('15002')}
                spacing={0}
                checked={this.props.filter.estimationApproved}
                onChange={this.props.onChange}
              />
            </Inline>

            <Inline spacing={0}>
              <Button size='m' style={'link'} spacing={0} labelText={17926} onClick={this.props.openFilterSlidePanel.bind(this, 'spareParts')} />
            </Inline>

            <Inline spacing={0}>
              <Button size='m' style={'link'} spacing={0} labelText={450} onClick={this.props.openFilterSlidePanel.bind(this, 'employee')} />
            </Inline>
          </div>
          <CloseButton size='s' spacing={0} ariaLabel={translation('394')} onClick={this.props.onClose} />
        </Grid>
      </div>
    )
  }
}

export default FilterBar



// WEBPACK FOOTER //
// ./src/app/shared/overlays/OrderCapacityOverview/filterBar/index.js